import type { UIStringsOverride } from "../i18n-ui.ts";

/** Slovak (sk) UI strings. */
export const sk: UIStringsOverride = {
  actions: {
    addToCursor: "Pridať do Cursoru",
    addToVscode: "Pridať do VS Code",
    askAI: "Opýtať sa AI na túto stránku",
    connectMcp: "Pripojiť k MCP",
    copied: "Skopírované!",
    copyClaudeCode: "Kopírovať príkaz Claude Code",
    copyCode: "Kopírovať kód",
    copyCodex: "Kopírovať príkaz Codex",
    copyMarkdown: "Kopírovať ako Markdown",
    copyServerUrl: "Kopírovať URL servera",
    edit: "Upraviť na GitHube",
    export: "Exportovať",
    exportEpub: "Exportovať do EPUB",
    exportPdf: "Exportovať do PDF",
    generating: "Generovanie…",
    openIn: "Otvoriť v {name}",
    openInChat: "Otvoriť v chate",
    scrollToTop: "Späť nahor",
  },
  ask: {
    ai: "AI",
    clear: "Vymazať konverzáciu",
    close: "Zavrieť",
    copy: "Kopírovať konverzáciu",
    empty: "Opýtajte sa na dokumentáciu.",
    error: "Ospravedlňujeme sa, niečo sa pokazilo.",
    label: "Položiť otázku",
    placeholder: "Položiť otázku…",
    send: "Odoslať",
    tip: "Tip: Chat môžete otvoriť a zavrieť pomocou",
    title: "Opýtať sa AI",
    you: "Vy",
  },
  banner: { dismiss: "Zavrieť oznámenie" },
  changelog: {
    description: "Novinky produktu a poznámky k vydaniu.",
    showReleases: "Zobraziť vydania {version}",
    title: "Zoznam zmien",
  },
  content: { diagramError: "Tento diagram sa nepodarilo vykresliť." },
  feedback: {
    no: "Nie",
    question: "Bola táto stránka užitočná?",
    thanks: "Ďakujeme za vašu spätnú väzbu!",
    yes: "Áno",
  },
  languageSwitcher: { label: "Jazyk", untranslated: "Nepreložené" },
  nav: {
    back: "Späť",
    breadcrumb: "Omrvinková navigácia",
    closeNavigation: "Zavrieť navigáciu",
    deprecated: "zastarané",
    featured: "Odporúčané",
    githubRepository: "Repozitár na GitHube",
    navigation: "Navigácia",
    primary: "Hlavné",
    sections: "Sekcie",
    toggleNavigation: "Prepnúť navigáciu",
    toggleTheme: "Prepnúť farebný motív",
  },
  notFound: {
    description: "Stránku, ktorú hľadáte, sa nepodarilo nájsť.",
    home: "Späť na úvodnú stránku",
    title: "Stránka sa nenašla",
  },
  page: {
    lastUpdated: "Naposledy aktualizované",
    next: "Ďalej",
    pagination: "Stránkovanie",
    previous: "Predchádzajúce",
    skipToContent: "Prejsť na obsah",
  },
  search: {
    all: "Všetko",
    allLanguages: "Všetky jazyky",
    askAi: "Opýtať sa AI",
    askAiHint: "Získajte okamžitú odpoveď od AI",
    button: "Hľadať",
    devOnly: "Vyhľadávanie je dostupné v produkčnom builde.",
    error: "Niečo sa pokazilo. Skúste to znova.",
    label: "Prehľadať dokumentáciu",
    navigate: "navigácia",
    noResults: "Nenašli sa žiadne výsledky.",
    open: "otvoriť",
    placeholder: "Prehľadať dokumentáciu…",
    popular: "Populárne",
    preview: "náhľad",
    results: "Výsledky",
  },
  toc: { title: "Na tejto stránke" },
};
